import { render } from "./LoginSignup.vue?vue&type=template&id=69435653&scoped=true"
import script from "./LoginSignup.vue?vue&type=script&lang=js"
export * from "./LoginSignup.vue?vue&type=script&lang=js"

import "./LoginSignup.vue?vue&type=style&index=0&id=69435653&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69435653"]])

export default __exports__